// Loads the Razorpay Checkout script on demand and opens the payment modal.
export const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

export const openRazorpay = ({ order, prefill, onSuccess, onDismiss }) =>
  new Promise(async (resolve) => {
    const ok = await loadRazorpayScript();
    if (!ok) { resolve(false); return; }
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency || 'INR',
      order_id: order.id,
      name: 'Gaze Decor',
      description: 'Luxury Home Decor',
      theme: { color: '#0F3D2E' },
      prefill,
      handler: (res) => { onSuccess?.(res); resolve(true); },
      modal: { ondismiss: () => { onDismiss?.(); resolve(false); } },
    });
    rzp.open();
  });
